"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var css_list_helpers_1 = require("css-list-helpers");
/**
 * Parses CSS sides (e.g., the value of `margin`, `padding` and `border` declarations).
 */
function parseSides(
/**
 * The CSS sides to parse (e.g., `0 5% 10px !important`).
 */
value) {
    var sides = css_list_helpers_1.splitBySpaces(value);
    var pos = sides.lastIndexOf('!important');
    var important = pos !== -1;
    if (important) {
        sides.splice(pos, 1);
    }
    var numberOfSides = sides.length;
    if (numberOfSides < 1 || numberOfSides > 4) {
        throw new Error("Cannot parse " + numberOfSides + " sides");
    }
    var first = sides[0], rest = sides.slice(1);
    return createSides.apply(void 0, [first].concat(rest));
    function createSides(top, right, bottom, left) {
        if (right === void 0) { right = top; }
        if (bottom === void 0) { bottom = top; }
        if (left === void 0) { left = right; }
        return __assign({ bottom: bottom,
            left: left,
            right: right,
            top: top }, (important ? { important: important } : {}));
    }
}
exports["default"] = parseSides;
// @ts-ignore
exports["default"]["default"] = module.exports = exports["default"];
